import Header from "../../componants/header";
import Footer from "../../componants/footer";
import BannerForAll from "../../componants/bannerForAll";
import cppImage from '../../images/cardpageimages/technicalcourse/cpp.png';
import IntroVideos from "../../componants/introvideos";
import CppLanguageModule from "../../componants/allCourseModule/TechnicalCourseModule/CppLanguageModule";

function CppLanguage() {
  return (
    <>
      <Header />
      <BannerForAll
        title="C++ LANGUAGE FULL COURSE"
        text="Our C++ Language Full Course is designed for those looking to dive deeper into object-oriented programming concepts. This course covers everything from basic syntax and data types to advanced topics like classes, inheritance, polymorphism, and memory management. Ideal for students and professionals, this course provides a comprehensive foundation to master C++ and expand into other object-oriented languages."
        imageone={cppImage}
        imagetwo={cppImage}
      />
      <IntroVideos
        vone="https://www.youtube.com/embed/dQw4w9WgXcQ"
        vtwo="https://www.youtube.com/embed/3JZ_D3ELwOQ"
        topic="C++ LANGUAGE"
      />
      <CppLanguageModule />
      <Footer />
    </>
  );
}

export default CppLanguage;
